import { z } from 'zod';
import { abilityNameSchema } from '../content/common.js';
import { contentIdSchema } from '../rules/content-id.js';
import { slotKeySchema } from './plan.js';
/**
 * Выборы, с которыми приходит создание персонажа.
 *
 * Это вход: то, что человек выбрал в визарде. Проверяет их
 * `packages/rules` против плана, собранного из контента, — сервер
 * ничего не решает сам (CLAUDE.md, п. 5).
 */
/** Значения характеристик по шести характеристикам — до прибавок. */
export const abilityAssignmentSchema = z.strictObject({
    strength: z.number().int(),
    dexterity: z.number().int(),
    constitution: z.number().int(),
    intelligence: z.number().int(),
    wisdom: z.number().int(),
    charisma: z.number().int(),
});
/**
 * Способ получения набора значений (SRD 5.2, с. 21).
 *
 * У броска значения приходят готовыми числами: движок кости
 * не бросает (D21.4), он лишь проверяет, что числа могли получиться
 * заявленным способом.
 */
export const abilityChoiceSchema = z.discriminatedUnion('method', [
    z.strictObject({
        method: z.literal('standard_array'),
        assignment: abilityAssignmentSchema,
    }),
    z.strictObject({
        method: z.literal('point_buy'),
        assignment: abilityAssignmentSchema,
    }),
    z.strictObject({
        method: z.literal('rolls'),
        /** Броски снаружи: столько чисел, сколько требует правило. */
        rolls: z.array(z.number().int()).min(1),
        assignment: abilityAssignmentSchema,
    }),
]);
/** Выбор варианта в слоте плана. */
export const slotPickSchema = z.strictObject({
    slot: slotKeySchema,
    value: z.string().min(1),
});
export const creationChoicesSchema = z.strictObject({
    name: z.string().min(1).max(80),
    species: contentIdSchema,
    class: contentIdSchema,
    background: contentIdSchema,
    abilities: abilityChoiceSchema,
    /**
     * Прибавки предыстории: характеристика → на сколько. Раскладка
     * проверяется против правила («+2 и +1» либо «+1 всем трём»).
     */
    increase: z.array(z.strictObject({
        ability: abilityNameSchema,
        amount: z.number().int().positive(),
    })),
    picks: z.array(slotPickSchema),
});
//# sourceMappingURL=choices.js.map